/* Joyce Giraud Beauty — AJAX Cart Drawer (vanilla JS, no jQuery) */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 7500; // $75.00 in cents

  /* ── Helpers ── */
  function request(url, data) {
    return fetch(url, {
      method: data ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    }).then(function (r) { return r.json(); });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── DOM refs ── */
  function el(id) { return document.getElementById(id); }

  /* ── Cart count badge ── */
  function updateBadge(count) {
    var badges = document.querySelectorAll('#bloom-cart-count, .bloom-cart-count');
    badges.forEach(function (b) {
      b.textContent = count;
      b.setAttribute('data-count', count);
    });
    var title = el('bloom-cart-item-count');
    if (title) title.textContent = count;
  }

  /* ── Shipping bar ── */
  function updateShipping(totalCents) {
    var fill  = el('bloom-shipping-fill');
    var label = el('bloom-shipping-label');
    if (!fill || !label) return;
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100));
    fill.style.width = pct + '%';
    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      label.textContent = '✨ You\'ve unlocked free shipping!';
      fill.style.background = '#4A1A2C';
    } else {
      var remaining = money(FREE_SHIPPING_THRESHOLD - totalCents);
      label.textContent = 'You\'re ' + remaining + ' away from free shipping';
      fill.style.background = '#C4957A';
    }
  }

  /* ── Render cart items ── */
  function renderCart(cart) {
    var itemsEl    = el('bloom-cart-items');
    var emptyEl    = el('bloom-cart-empty');
    var subtotalEl = el('bloom-cart-subtotal');
    if (!itemsEl) return;

    updateBadge(cart.item_count);
    updateShipping(cart.total_price);

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)$/, '_72x72$1') + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="bloom-cart-item__img" width="72" height="72" loading="lazy">'
        : '<div class="bloom-cart-item__img" style="background:#E8D9CC;"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="bloom-cart-item__variant">' + item.variant_title + '</p>' : '';
      return '<li class="bloom-cart-item" data-key="' + item.key + '">'
        + img
        + '<div class="bloom-cart-item__info">'
        + '<p class="bloom-cart-item__name">' + item.product_title + '</p>'
        + variant
        + '<div class="bloom-cart-item__row">'
        + '<div class="bloom-qty">'
        + '<button class="bloom-qty__btn" data-bloom-qty="-1" data-key="' + item.key + '" aria-label="Decrease">−</button>'
        + '<span class="bloom-qty__count">' + item.quantity + '</span>'
        + '<button class="bloom-qty__btn" data-bloom-qty="1" data-key="' + item.key + '" aria-label="Increase">+</button>'
        + '</div>'
        + '<span class="bloom-cart-item__price">' + money(item.line_price) + '</span>'
        + '</div>'
        + '<button class="bloom-cart-item__remove" data-bloom-remove data-key="' + item.key + '">Remove</button>'
        + '</div>'
        + '</li>';
    }).join('');
  }

  /* ── Fetch cart ── */
  function fetchCart() {
    return request('/cart.js').then(renderCart);
  }

  /* ── Drawer open/close ── */
  function openDrawer() {
    var drawer  = el('bloom-cart-drawer');
    var overlay = el('bloom-cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    var drawer  = el('bloom-cart-drawer');
    var overlay = el('bloom-cart-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── Add to cart ── */
  function addToCart(variantId, qty) {
    qty = qty || 1;
    return request('/cart/add.js', { id: variantId, quantity: qty })
      .then(function () { openDrawer(); })
      .catch(function (err) { console.error('ATC error', err); });
  }

  /* ── Update quantity ── */
  function updateQuantity(key, delta) {
    return request('/cart.js').then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) return;
      var newQty = item.quantity + delta;
      if (newQty <= 0) return removeItem(key);
      return request('/cart/change.js', { id: key, quantity: newQty }).then(renderCart);
    });
  }

  /* ── Remove item ── */
  function removeItem(key) {
    return request('/cart/change.js', { id: key, quantity: 0 }).then(renderCart);
  }

  /* ── Event delegation ── */
  document.addEventListener('click', function (e) {
    /* Open drawer */
    if (e.target.closest('[data-bloom-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    /* Close drawer */
    if (e.target.closest('.bloom-cart-close') || e.target === el('bloom-cart-overlay')) {
      closeDrawer();
      return;
    }
    /* Qty buttons */
    var qtyBtn = e.target.closest('[data-bloom-qty]');
    if (qtyBtn) {
      var key   = qtyBtn.dataset.key;
      var delta = parseInt(qtyBtn.dataset.bloomQty, 10);
      updateQuantity(key, delta);
      return;
    }
    /* Remove */
    var removeBtn = e.target.closest('[data-bloom-remove]');
    if (removeBtn) {
      removeItem(removeBtn.dataset.key);
      return;
    }
    /* ATC button */
    var atcBtn = e.target.closest('[data-bloom-atc]');
    if (atcBtn && !e.target.closest('form')) {
      var vid = atcBtn.dataset.variantId;
      if (vid) addToCart(parseInt(vid, 10), 1);
      return;
    }
  });

  /* ── ATC form submit ── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-bloom-atc-form]');
    if (!form) return;
    e.preventDefault();
    var idInput  = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput) return;
    var vid = parseInt(idInput.value, 10);
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    addToCart(vid, qty);
  });

  /* Overlay click */
  var overlay = el('bloom-cart-overlay');
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* Init badge on load */
  fetchCart();

  /* Public API */
  window.BloomCart = { open: openDrawer, close: closeDrawer, add: addToCart, refresh: fetchCart };
})();
